import { type AudiFinancingModuleSpecsFragment } from '../../../../../api/fragments';
import UpdateSalesPersonCodeMappingForm from './UpdateSalesPersonCodeMappingForm';

type SalesPersonCodeMappingsProps = {
    module: AudiFinancingModuleSpecsFragment;
};

const SalesPersonCodeMappings = ({ module }: SalesPersonCodeMappingsProps) => (
    <UpdateSalesPersonCodeMappingForm module={module} />
);
export default SalesPersonCodeMappings;
